import React, { useEffect, useState } from "react";
import { Table, Space, Row, Col, Input, Select, Button, Pagination, Tag } from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { invoiceService } from "../../../services";
import { withDefaultRender } from "../../../utils/tableDefaultRender";
import { changeDocumentTitle } from "../../../utils/title";

function CustomerInvoices({ showSearch = true, pag = true, limit = null, showAction = true }) {
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [search, setSearch] = useState(null)


  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "9",
      label: "9",
    },
  ];

  // const addBusinessDays = (date, days) => {
  //   let result = new Date(date);
  //   let added = 0;

  //   while (added < days) {
  //     result.setDate(result.getDate() + 1);

  //     // Skip Saturday (6) and Sunday (0)
  //     if (result.getDay() !== 0 && result.getDay() !== 6) {
  //       added++;
  //     }
  //   }

  //   return result;
  // };

  // // helper: format DD-MM-YYYY
  // const formatDate = (date) => {
  //   const d = new Date(date);
  //   const day = String(d.getDate()).padStart(2, "0");
  //   const month = d.toLocaleString("en-US", { month: "short" }); // Jan, Feb, Mar...
  //   const year = d.getFullYear();
  //   return `${day}-${month}-${year}`;
  // };

  const columns = withDefaultRender([
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Invoice No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Issue Date",
      dataIndex: "date",
      key: "date",
      // render: (text) => {
      //   if (!text) return "-";
      //   return formatDate(text);
      // }
    },
    {
      title: "Due Date",
      dataIndex: "due_date", // use the same issue date field
      key: "due_date",
      // render:(text)=>text === text
      // render: (text) => {
      //   if (!text) return "-";
      //   const issueDate = new Date(text);
      //   const dueDate = addBusinessDays(issueDate, 6);
      //   return formatDate(dueDate);
      // }
    },
    {
      title: "Container No",
      dataIndex: "container_number",
      key: "container_number",
      render: (text) => text || "N/A"
    },
    {
      title: "Booking No",
      dataIndex: "vehicles",
      key: "vehicles",
      render: (vehicles) => vehicles?.[0]?.booking_no || "-"

    },
    {
      title: "Payment Status",
      dataIndex: "is_partial",
      key: "is_partial",
      render: (text) => (
        <Tag
          size="small"
          color={text === 1 ? "orange" : text === 2 ? "green" : "yellow"}
        >
          {text === 1 ? "Partial" : text === 2 ? "Paid" : "Unpaid"}
        </Tag>
      ),
    },
    showAction && {
      title: "Action",
      key: "Action",
      render: (text, record, { _id }) => (
        <Space size="small">
          {/* <Link to="/vehicles/edit">
            <Button type="primary" size="small">
              <EditOutlined />
            </Button>
          </Link> */}

          {/* <Link to={`/invoice/view/${record.id}`}> */}
          <Link to={`/invoice/view/${record.id}`} className="hover:text-primary" >
            {/* <Button type="primary" size="small"> */}
            <EyeOutlined style={{ fontSize: "15px" }} />
            {/* </Button> */}
          </Link>
          {/* </Link> */}
          {/* onClick={() => showModal(record)} */}
          {/* <Button type="primary" size="small">
            <DeleteOutlined />
          </Button> */}
        </Space >
      ),
    },

  ]);

  const initialize = async (page = 1, pageSize = pagination.current, search = null) => {
    setLoading(true);
    const { success, data } = await invoiceService.fetchCustomerInvoices(page, pageSize, search);
    setLoading(false);
    if (success) {
      setInvoices(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };

  useEffect(() => {
    changeDocumentTitle(" Invoices");
    initialize(pagination.current, pagination.pageSize, search);
  }, [search]);
  return (
    <div className="customer1-table-wrapper" >
      {showSearch && (
        <div className="flex justify-end">
          <Input
            placeholder="Search by Invoice no & Container no"
            prefix={<SearchOutlined />}
            style={{
              width: "33%",
              borderRadius: "20px",
              fontSize: 14,
              margin: 6
            }}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      )}

      <Row gutter={24}>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={limit ? invoices.slice(0, limit) : invoices}
            // dataSource={dummyInvoices}
            loading={loading}
            // scroll={{ x: "max-content" }}
            style={{ marginTop: "8px" }}
            pagination={false}
            // pagination={{
            //   current: pagination.current,
            //   total: pagination.total,
            //   pageSize: pagination.pageSize,
            //   onChange: (page) => initialize(page, pagination.pageSize),
            //   showSizeChanger: false,
            // }}

            footer={
              pag ? () => (
                <div className="flex justify-between items-center ">
                  <div className="text-xs text-gray-600">
                    Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                    {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                    {pagination.total} entries
                  </div>
                  <Pagination
                    current={pagination.current}
                    total={pagination.total}
                    pageSize={pagination.pageSize}
                    showSizeChanger={false}
                    onChange={(page) => initialize(page, pagination.pageSize, search)}
                    itemRender={(current, type, originalElement) => {
                      if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                      if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                      return originalElement;
                    }}
                  />
                </div>
              ) : null
            }

          />

        </Col>
      </Row>
    </div>
  );
}

export default CustomerInvoices;
